import React from 'react';
import SubHeading from '../../common/SubHeading';
import Checkbox from '../../common/Checkbox';
import { IntakeFormData } from '../../../lib/types/IntakeFormTypes';

interface CheckboxGroupProps {
  title: string;
  questions: { key: string; label: string }[];
  sectionKey: string;
  data: IntakeFormData['symptomAssessment'];
  handleChange: (path: string, value: unknown) => void;
  disabled?: boolean;
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({title, questions, sectionKey, data, handleChange, disabled}) => (
    <div>
        <SubHeading>{title}</SubHeading>
        <p className="mb-2 text-brand-stone-600">Check the selection(s) that apply</p>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 bg-brand-stone-50 p-4 rounded-lg">
            {questions.map((q) => (
                 <Checkbox
                    key={q.key}
                    label={q.label}
                    path={`symptomAssessment.${sectionKey}.${q.key}`}
                    checked={!!data[sectionKey]?.[q.key]}
                    onChange={handleChange}
                    disabled={disabled}
                />
            ))}
        </div>
    </div>
);

export default CheckboxGroup;